import { useEffect } from "react";

import { useUser } from "@components/user-context";

import { useIsDarkMode } from "./use-is-dark-mode";

export const useV2ColorDesigns = () => {
  const { user } = useUser();

  const [isDarkMode] = useIsDarkMode();

  useEffect(() => {
    if (
      // Have to do it this way because hook is not in the feature flag provider
      user.featureFlags.enableDashboardV2
    ) {
      document.body.classList.add("v2");
      if (isDarkMode) {
        document.body.classList.add("dark-mode");
      } else {
        document.body.classList.remove("dark-mode");
      }
    } else {
      document.body.classList.remove("v2");
      document.body.classList.remove("dark-mode");
    }
  }, [user.featureFlags, isDarkMode]);
};
